export default "__VITE_ASSET__BxVsWHOl__"